export const json = {
  locale: 'zh_cn',
  recipe: "配方",
  machine: "机器",
  task: {
    state: {
      unset: "未设置",
      todo: "待办",
      in_progress: "进行中",
      to_test: "待测试",
      wont_fix: "不修复",
      done: "已完成",
      paused: "已暂停",
    },
    priority: {
      unset: "无优先级",
      low: "低",
      normal: "普通",
      high: "高",
      max: "紧急",
    },
    table: {
      header: {
        title: "任务",
        state: "状态",
        priority: "优先级",
        labels: "标签",
      },
      placeholder: {
        filter: {
          priority: "筛选邮件...",
        },
      },
      "no-results": "无结果",
    },
    add: {
      title: "添加新任务",
      name: "任务名称",
      name_placeholder: "输入任务名称",
      priority: "优先级",
      title_translations: "标题翻译",
      description_translations: "描述翻译",
      icon_url: "图标URL（可选）",
      icon_url_placeholder: "输入图标URL",
      labels: "标签",
      assigned_to: "分配给",
      assigned_to_placeholder: "选择版主",
      submit: "创建任务",
      cancel: "取消",
      edit_translations: "编辑翻译",
      save_translations: "保存翻译",
      required_field: "此字段为必填项",
      en_us_required: "英语（美国）翻译为必填项",
      success: "任务创建成功！",
      error: "创建任务时出错。请重试。",
    },
  },
  table: {
    select: {
      of: "的",
      rows: "行已选择。",
    },
  },
  cookies: {
    link: 'Cookie政策',
    title: "Cookie同意",
    description:
      "本网站使用Cookie来确保其正常运行并改善您的体验。请选择您允许我们使用的Cookie。",
    policy_link: "在我们的Cookie政策中了解更多",
    accept_all: "接受全部",
    accept_selected: "接受已选",
    accept_essential: "仅必要",
    manage: "管理偏好",
    save: "保存偏好",
    back: "返回",
    categories: {
      essential: {
        title: "必要Cookie",
        description: "这些Cookie对网站功能是必需的，不能禁用。",
      },
      functional: {
        title: "功能Cookie",
        description: "这些Cookie启用个性化功能和特性。",
      },
      analytics: {
        title: "分析Cookie",
        description: "这些Cookie帮助我们了解访问者如何与网站互动。",
      },
      marketing: {
        title: "营销Cookie",
        description: "这些Cookie用于跟踪网站上的访问者，用于广告目的。",
      },
    },
    expiration: {
      title: "Cookie过期",
      description: "选择您的Cookie偏好将被记住多长时间：",
      thirty_days: "30天",
      ninety_days: "90天",
      six_months: "6个月",
      one_year: "1年",
    },
    policy: {
      title: "Cookie政策",
      introduction:
        "本Cookie政策解释了我们如何使用Cookie和类似技术在您访问我们的网站时识别您。它解释了这些技术是什么以及我们为什么使用它们，以及您控制我们使用它们的权利。",
      what_are_cookies: "什么是Cookie？",
      what_are_cookies_text:
        "Cookie是在您访问网站时放置在您的计算机或移动设备上的小数据文件。网站所有者广泛使用Cookie来使其网站运行，或更有效地运行，以及提供报告信息。",
      how_we_use: "我们如何使用Cookie",
      how_we_use_text:
        "我们出于多种原因使用Cookie。一些Cookie出于技术原因对我们网站的运行是必需的，我们称之为'必要'或'必需'Cookie。其他Cookie使我们能够跟踪和定位用户的兴趣，以增强我们网站上的体验。第三方通过我们的网站提供Cookie，用于广告、分析和其他目的。",
      types: "我们使用的Cookie类型",
      managing: "管理您的Cookie",
      managing_text:
        "您可以设置或修改您的Web浏览器控件来接受或拒绝Cookie。如果您选择拒绝Cookie，您仍然可以使用我们的网站，尽管您对我们网站的某些功能和区域的访问可能会受到限制。由于您可以通过Web浏览器控件拒绝Cookie的方式因浏览器而异，您应该访问您的浏览器的帮助菜单以获取更多信息。",
      third_party: "第三方Cookie",
      third_party_text:
        "除了我们自己的Cookie外，我们还可能使用各种第三方Cookie来报告网站使用统计数据，在网站上和通过网站投放广告等。",
      updates: "本Cookie政策的更新",
      updates_text:
        "我们可能会不时更新本Cookie政策，例如，反映我们使用的Cookie的变化或出于其他运营、法律或监管原因。因此，请定期重新访问本Cookie政策，以了解我们使用Cookie和相关技术的最新信息。",
      purpose: "目的",
      essential_purpose:
        "对网站的正常运行是必需的。这些Cookie启用基本功能，如页面导航和访问网站的安全区域。",
      functional_purpose:
        "允许网站记住您做出的选择（如您的用户名、语言或您所在的地区），并提供增强的、更个性化的功能。",
      analytics_purpose:
        "通过匿名收集和报告信息，帮助我们了解访问者如何与我们的网站互动。",
      marketing_purpose:
        "用于跟踪网站上的访问者。目的是向个别用户显示相关且吸引人的广告。",
      always_active: "始终激活",
      active: "激活",
      inactive: "未激活",
      back_to_site: "返回网站",
    },
  },
  sidebar: {
    platform: "平台",
    dashboard: "仪表板",
    tasks: {
      title: "任务",
      add: "添加任务"
    },
    analytics: "分析",
    users: "用户",
    settings: "设置",
    admin_panel: {
      title: "管理面板",
      mods: {
        title: "版主",
        add: "添加版主"
      },
      labels: {
        title: "标签",
        add: "添加标签"
      },
      pending: "待批准"
    },
    documentation: {
      title: "文档",
      create: "创建文档"
    },
    search: "搜索文档..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "概览",
          userInfo: "用户信息",
          userId: "用户ID",
          role: "角色",
          memberSince: "成员自"
        },
        tasks: {
          title: "任务",
          assigned: "已分配任务",
          noTasks: "尚未分配任务。"
        },
        activity: {
          title: "活动",
          recent: "最近活动",
          noActivity: "没有最近活动。"
        },
        settings: {
          title: "设置",
          user: "用户设置",
          admin: "此用户的管理员设置。"
        }
      }
    },
    mods: {
      error: {
        unknownError: "未知错误"
      },
      access: {
        title: "访问被拒绝",
        description: "您没有权限访问此页面。"
      },
      add: {
        link: "添加新模组",
        title: "添加新模组",
        addDesc: "创建新模组条目",
        name: {
          title: "名称",
          placeholder: "输入模组名称"
        },
        description: {
          title: "描述",
          placholder: "输入描述 "
        },
        optional: "可选",
        versions: {
          title: "版本",
          add: "添加版本"
        },
        icon: "图标URL",
        launchers: "启动器",
        form: {
          errors: {
            alert: {
              title: "错误",
              description: "提交前请修正上述错误。"
            },
            name: "名称为必填项",
            description: "英语（美国）描述为必填项",
            curseforge: "CurseForge链接为必填项",
            invalidURL: "无效的URL格式",
            versions: "至少需要一个版本",
            launchers: "至少需要一个启动器"
          }
        },
        cancel: "取消",
        create: {
          loading: "创建中...",
          default: "创建模组"
        },
        langDataError: "加载语言数据时出错：",
      },
      noMods: "未找到模组",
      getStarted: "通过创建新模组开始。",
      fetch: {
        error: '获取文档时出错：'
      },
      "delete": {
        link: "删除",
        confirm: "您确定要删除此模组吗？"
      },
      toast: {
        delete: {
          success: {
            title: "模组已删除",
            description: "模组已成功删除。"
          },
          error: {
            console: "删除模组时出错：",
            fallback: "删除模组失败",
            title: "错误",
            description: "删除模组时发生错误。"
          }
        },
        edit: {
          success: {
            title: "成功",
            description: "模组已成功更新"
          }
        },
        add: {
          fallback: "创建模组失败",
          success: {
            title: "成功",
            description: "模组已成功创建"
          },
          console: "创建模组时出错：",
          error: {
            title: "错误",
            description: "创建模组失败"
          }
        }
      },
      noDesc: "无可用描述",
      docs: {
        link: "文档"
      },
      edit: {
        link: "编辑",
        title: "编辑模组",
        langDataError: "加载语言数据时出错：",
        notFound: "未找到模组",
        failFetch: "获取模组失败",
        unknownError: "发生未知错误",
        form: {
          errors: {
            name: "名称为必填项",
            description: "英语（美国）描述为必填项",
            curseforge: "CurseForge链接为必填项",
            versions: "所有版本字段必须填写",
            launchers: "必须选择至少一个启动器"
          }
        },
        modInfo: "模组信息",
        editModInfo: "编辑模组信息。",
        name: "名称",
        description: {
          title: "描述",
          required: "英语（美国）描述为必填项。"
        },
        optional: "可选",
        versions: {
          title: "版本",
          add: "添加版本",
          remove: "移除"
        },
        icon: "图标URL",
        launchers: "启动器",
        cancel: "取消",
        update: "更新模组"
      }
    },
    docs: {
      access: {
        title: "访问被拒绝",
        description: "您没有权限访问此页面。"
      },
      title: "文档",
      description: "浏览并阅读Minecraft模组的文档",
      create: {
        link: "创建文档",
        tab: "创建新文档",
        content: {
          title: "没有可用模组",
          description: "所有模组已有文档或您没有权限为任何模组创建文档。"
        },
        title: "创建文档"
      },
      published: "已发布",
      pending: "待审核",
      noDocs: {
        title: "没有可用文档",
        description: "尚无已发布的文档页面。"
      },
      noPending: {
        title: "没有待审核文档",
        superAdmin: "没有等待批准的文档页面",
        rest: "您没有待审核的文档页面。"
      },
      user: {
        noDocs: {
          title: "没有可用文档",
          description: "尚无已发布的文档页面。"
        }
      },
      card: {
        pending: "等待批准",
        view: "查看",
        edit: "编辑"
      },
      add: {
        title: "创建新文档",
        description: "为Minecraft模组创建全面的文档",
        noMods: {
          title: "没有可用模组",
          description: "没有可用于创建文档的模组。要么所有模组已有文档，要么您没有权限为任何模组创建文档。"
        },
        card: {
          title: "基本信息",
          description: "提供有关文档的基本信息。",
          descriptionLink: "查看我们的文档指南",
          content: {
            modSelect: "选择模组",
            modSelectDesc: "选择您想为其创建文档的模组",
            noDesc: "无可用描述",
            form: {
              title: {
                title: "标题",
                placeholder: "输入文档标题",
                description: "您的文档标题（需要英语US）"
              },
              description: {
                title: "描述",
                placeholder: "输入文档描述",
                description: "您的文档的简短描述（需要英语US）"
              },
              coverImage: {
                title: "封面图片URL（可选）",
                description: "提供您的文档封面图片的URL"
              },
              tabs: {
                preview: {
                  title: "预览",
                  content: {
                    title: "预览",
                    description: "您的文档将如何显示的预览",
                    form: {
                      title: "文档标题",
                      description: "文档描述将显示在这里。"
                    },
                    section: "章节",
                    article: "文章",
                    modSelect: {
                      title: "选择模组",
                      description: "选择一个模组以预览您的文档"
                    }
                  }
                },
                information: {
                  title: "信息",
                  content: {
                    title: "信息",
                    description: "关于创建文档的重要信息",
                    approval: {
                      title: "需要批准",
                      description: "编辑者和管理员创建的文档在公开前需要超级管理员的批准。请开启工单请求此操作。"
                    },
                    after: {
                      title: "创建后：",
                      list: {
                        one: "您将被重定向到文档编辑器",
                        two: "将自动创建默认章节和文章",
                        three: "您可以根据需要添加更多章节和文章",
                        four: "您可以上传图片并添加自定义组件",
                        five: "您可以在提交批准前预览您的文档。（预览前必须保存）"
                      }
                    },
                    create: {
                      loading: "创建中...",
                      default: "创建文档"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "获取模组失败",
          documentation: "获取文档失败"
        },
        success: {
          title: "文档已创建",
          description: "您的文档已成功创建。"
        },
        error: {
          fetching: {
            mods: {
              console: "获取模组时出错：",
              toast: {
                title: "错误",
                description: "加载模组失败。请重试。"
              }
            }
          },
          creating: {
            failed: "创建文档失败",
            error: {
              console: "创建文档时出错：",
              toast: {
                title: "错误",
                description: "创建文档失败。请重试。"
              }
            }
          }
        }
      }
    }
  }
}